<template>
    <div class="box_content">
        <div class="table-responsive table_bordered">
            <table class="table mb-0">
                <thead>
                    <tr>
                        <th class="ps-3">Evento</th>
                        <th  class="actions"></th>
                    </tr>
                </thead>
                <tbody v-if="events_mautic.length">
                    <tr v-for="(row, key) in events_mautic" class="divisor_bottom" :key="key">
                        <td>
                            {{ row.type }}
                        </td>
                        <td class="actions">
                            <button @click.middle="editEventBlank(row.id)" @click="editEvent(row.id)" type="button" class="icon_buttons">
                                <font-awesome-icon icon="fa-solid fa-pen-to-square" />
                            </button>
                            <button @click="openPopup(row.id)" type="button" class="icon_buttons icon_view">
                                <font-awesome-icon icon="fa-solid fa-trash-can" />
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
            <h6 v-if="!events_mautic.length" class="text-center p-4 mb-0 divisor_bottom">Nenhum resultado encontrado</h6>
        </div>
        <div style="text-align:center;" class="p-4">
            <BaseButton @click="createEvent" class="btn-success btn-lg">
                Adicionar
            </BaseButton>
        </div>
        <router-view></router-view>
        <BasePopup v-if="confirmAction" closeType="stayOnPage" width="400" @clickToClose="clickToClose">
            <div class="confirm_action">
                <div class="popup ">
                    <p class="title">Atenção</p>
                    <p class="text">Deseja remover este evento?</p>
                    <h6>Escreva a palavra "EXCLUIR" para confirmar.</h6>
                    <BaseInput
                        label=''
                        type="text"
                        id="excludeTextConfirm"
                        v-model="excludeTextConfirm"
                        :page="route.name"
                        class="col-12 mb-3"
                    />
                    <baseButton @click="clickToClose" style="width:110px" class="btn-secondary me-2">Cancelar</baseButton>
                    <baseButton @click="removeEvent" style="width:150px" class="btn-success ms-2" :disabled="excludeTextConfirm == 'EXCLUIR' || excludeTextConfirm == 'excluir'  ? false : true">Sim, remover</baseButton>
                </div>
            </div> 
        </BasePopup>
    </div>
</template>

<script setup>
import { computed, onBeforeMount, ref, shallowRef } from 'vue';
import { storeToRefs } from 'pinia';
import { useRoute, useRouter } from 'vue-router'
import { useProductStore } from "@/stores/products";
import { useGlobalStore } from '@/stores/global';

const productStore = useProductStore();
const { events_mautic }  = storeToRefs(productStore); 

const globalStore = useGlobalStore();

const route = useRoute();
const router = useRouter();

const isLoaded = ref(false);
const confirmAction = shallowRef(null);
const excludeTextConfirm = ref(null);

const product_id = computed (function () {
    return route.params.id;
});

let eventToDelete = null;
let isDeleting = false;

onBeforeMount(() =>{
    if(productStore.events_mautic != undefined){
        isLoaded.value = true
    } else {
        productStore.tryEventsMautic().then(() =>{
            isLoaded.value = true
        })
    }
})

function editEvent(id){
    globalStore.loader('show');
    productStore.tryEventMautic(id).then(() =>{
        router.push('/products/' + product_id.value + '/events/mautic/' + id)
        globalStore.loader('hide');
    })
}

function editEventBlank(id){
    window.open('/products/' + product_id.value + '/events/mautic/' + id)
}

function createEvent(){
    router.push('/products/' + product_id.value + '/events/mautic/new')
}

async function removeEvent(){
    if(!isDeleting && eventToDelete && excludeTextConfirm.value == 'EXCLUIR' || excludeTextConfirm.value == 'excluir') {
        globalStore.loader('show');
        await productStore.tryDeleteEventMautic(eventToDelete).then(function(success) {
            isDeleting = false;
            if(success){
                productStore.tryEventsMautic().then(function() {
                    globalStore.loader('hide');
                    isDeleting = false;
                    confirmAction.value = null;
                    router.push(route.path)
                });
            }else {
                globalStore.loader('hide');
                isDeleting = false;
            }
            excludeTextConfirm.value = null;
        }); 
    }
}

function openPopup(id) {
    eventToDelete = id
    confirmAction.value = true
    excludeTextConfirm.value = null;
}

function clickToClose() {
    confirmAction.value = null;
}

</script>

<style scoped> 

</style>